export const REDUCER_NAME = "deliveryManSlice";

export interface iDeliveryDTO {
    id?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    mobile?: string;
    address?: string;
    identityNumber?: string;
    identityType?: string;
    password?: string;
    confirmPassword?: string;
    identityImage?: string | File;
    profilePicture?: string | File;    
}

export interface iDeliveryRespone {
    id?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    mobile?: string;
    address?: string;
    identityNumber?: string;
    identityType?: string;
    password?: string;
    confirmPassword?: string;
    identityImage?: string | File;
    profilePicture?: string | File;
    wallet: iwallet;
    bankName: string | null;
    accountHolderName: string | null;
    accountNumber: string | null; 
    ifscCode: string | null;
}

export interface iwallet {
    currentBalance: number | null;
    totalWithdrawn: number | null;
    pendingWithdraw: number | null;
    withdrawableBalance: number | null;
}

export interface iDeliveryState {
    deliveryManList: iDeliveryRespone[] | null;
    deliveryManOrderList: any[] | null;
    isLoading: boolean;
    errorMessage: string | null;
}

// ✅ NEW: Interface for updating order status
export interface iUpdateOrderStatusPayload {
    orderId: string;
    status: string;
    images?: File[];
}